import { IS_TRIIVCO_APP } from "../config/constant";
import MasterService from "./MasterService";

const serviceList = {
	...MasterService,
	// THIS IS SAMPLE SERVICE FUNCTION
	getLeadList(body) {
		return this.post("/lead/get_lead_list", body);
	},

	getLeadHistroy(body) {
		return this.post("payment/history", body);
	},

	financierPaymentList(body) {
		return this.post("payment/list", body);
	},
	userLogin(body) {
		return this.post("user/login", body);
	},
	userOtpSend(body) {
		return this.post("user/send-otp", body);
	},
	userLogOut(body) {
		return this.post("user/logout", body);
	},
	userList(body) {
		return this.post("account/list_account", body);
	},
	savePaymentDetails(body,lead_source='') {
		if(['dealer-wallet','agent-wallet','agent-biru-wallet'].includes(lead_source)) {
			return this.post("/payment/save_wallet_payment", body);
		} else if (['dealer-incentive','dynamic-booster-encashment'].includes(lead_source)) {
			return this.post("/reward/entry_update", body);
		} else if (['sales-incentive-payout'].includes(lead_source)) {
			return this.post("/user-incentive/entry-update", body)
		}else {
			return this.post("/payment/save", body);
		}	
	},
	removePaymentDetails(body) {
		return this.post("/payment/remove", body);
	},
	importPayment(body, bodyType) {
		console.log(body);
		return this.post(bodyType['data-import'] == 'inbound' ? "fam/inbound_payment/import" : "/payment/import", body);
	},
	getConfig(body) {
		return this.post("/config/get_data", body);
	},
	updateAssignedLead(body) {
		return this.post("/lead/update_assigned_lead", body);
	},
	getLeadDetails(body) {
		return this.post("/lead/details", body);
	},
	updateLead(body) {
		if(body.lead_source === 'hrf'){
			return this.post("/hrf/update_lead", body);
		}else{ 
			if(body.tab_name === 'lost_loan' || +body?.is_resubmit === 1 || +body?.isOnhold || +body?.is_rejected ){
				return this.post("/lead/update_lead_status", body);
			}else{
				return this.post("/lead/update_lead_info", body);
			}
		}
		
	},

	isDealerLimitBreached(body) {
		return this.post("/lead/is_dealer_limit_breached", body);
	},

	saveApprovalDocs(body) {
		return this.post("/lead/save_approval_docs", body);
	},

	getNotificationList(body) {
		return this.get("/notification/list", body);
	},
	readNotification(body) {
		return this.post("/notification/read/" + body);
	},
	updateUserLoginStatus(body) {
		return this.post("user/status-update", body);
	},
	getReport(body) {
		return this.post("reports/get_report", body);
	},
	additionalRevenueList(body) {
		return this.post("payment/additional-revenue/list", body);
	},
	addAdditionalRevenue(body, headers) {
		return this.post("payment/save/additional-revenue", body, headers);
	},
	famSavePayment(body) {
		return this.post("fam/inbound_save_payment", body);
	},
	getOutbondList(body) {
		return this.post("fam/get_outbound_list", body);
	},
	getDealerIncentiveList(body) {
		return this.post("fam/get_user_incentive_outbound_list", body);
	},
	finacierPaymentList(body) {
		return this.get("fam/inbond_finacier_payment_list", body);
	},
	getPaymentList(body) {
		return this.post("fam/inbound_payment_list", body);
	},
	exportInboundReport(body) {
		return this.post("fam/export_inbound_report", body);
	},
	getInboundList(body) {
		return this.post("fam/get_inbound_list", body);
	},
	inboundUpdatePayment(body) {
		return this.post("fam/inbound_update_payment", body);
	},
	closeLoan(body) {
		return this.post("fam/close_loan", body);
	},
	getAllUserRolesList(body) {
		return this.post("account/roles", body);
	},
	getAllUserList(body) {
		return this.post("account/list_all", body);
	},
	saveRole(body) {
		return this.post("account/save_role", body);
	},
	saveUser(body) {
		return this.post("account/save", body);
	},
	featureList(body) {
		return this.post("user/feature_list", body);
	},
	updateRoleStatus(body) {
		return this.post("user/role_status_update", body);
	},
	addReportRemarks(body) {
		return this.post("reports/add_report_remarks", body);
	},
	getReportRemarks(body) {
		return this.post("reports/get_report_remarks", body);
	},
	bulkUploadPayment(body) {
		return this.post("/fam/upload_payment", body);
	},
	getMarkAsLostLeadTranch(body) {
		return this.post("/fam/get_lad_leads", body);
	},
	getLostAfterDisbursalLead(body) {
		return this.post("/fam/get_lad_payment_list", body);
	},
	resetAllocation(body) {
		return this.post("/fam/reset-allocation", body);
	},
	additionalRevenueHistoryList(body) {
		return this.post("payment/additional-revenue/history", body);
	},
	verifyTranches(body, lead_source = '') {
		if (lead_source === 'dealer-incentive' || lead_source === 'dynamic-booster-encashment' ) {
			return this.post("/reward/entry_create", body);
		} else if(lead_source === 'sales-incentive-payout'){
			return this.post("/user-incentive/entry-create", body);
		}else {
			return this.post("/fam/verify_tranches", body);
		}
	},
	updateAssignedTranchLead(body, tabsource) {
		if (tabsource === 'dealer-incentive' || tabsource === 'dynamic-booster-encashment' || tabsource === "sales-incentive-payout") {
			if(tabsource === 'sales-incentive-payout'){
				return this.updateUserIncentiveAssign(body);
			}else{
			return this.updateAssignedRewardLead(body);
			}
		} else {
			return this.post("/fam/assinged_users", body);
		}
	},
	matchingStatement(body) {
		return this.post("/recon/get_matching_statement", body);
	},
	updateManuallyMatchedStatus(body) {
		return this.post("/recon/update_manually_matched_status", body);
	},
	markAsOtherTransaction(body) {
		return this.post("/fam/mark_as_other_trans", body);
	},
	getOtherTransactionsList(body) {
		return this.post("/fam/get_other_transactions", body);
	},
	getOtherTransactionRemarks(body) {
		return this.post("/fam/get_other_transaction_remarks", body);
	},
	saveOtherTransactionRemarks(body) {
		return this.post("/fam/save_other_transaction_remark", body);
	},	
	getStatementReport(body) {
		return this.post("/recon/get_statement_report", body);
	},
	bulkMatchReconRecords(body) {
		return this.post("/recon/bulk_match_records", body);
	},
	syncBankInfo(body) {
		return this.post("/lead/sync_bankinfo_to_loanbox", body);
	},
	updatePpdFlag(body) {
		return this.post("/lead/update_ppd_flag", body);
	},
	loginCaptcha(body){
		return this.get("/user/getCaptchaImage", body);
	},

	updateCustomerMobileStatus(body) {
		return this.post("/lead/update_customer_mobile_status", body);
	},
	getCustomerMobile(body) {
		return this.post("/lead/get_customer_mobile", body);
	},
	getWalletOutboundList(body) {
		return this.post("/fam/get_wallet_outbound_list", body);
	},
	updateAssignedRewardLead(body) {
		return this.post("/reward/update_assigned_reward", body);
	},

	getPendingPaymentConfirmationList(body) {
		return this.post("/payment/get_payment_pending_list", body);
	},
	updatePendingPaymentStatus(body) {
		return this.post("/payment/update_pending_payment_status", body);
	},
	updateDocumentStatus(body) {
		return this.post("/lead/update_document_status", body);
	},
	exportInboundServiceFeeReport(body) {
		return this.post("fam/export_inbound_service_fee_report", body);
	},
	importServiceFeePayment(body, bodyType) {
		return this.post("fam/inbound_payment/service_fee_import", body);
	},
	validateGoogleLogin(body) {
		return this.post("user/validate_google_login", body);
	},
	getInboundRemarksHistory(body) {
		return this.post("/fam/get_inbound_remarks", body);
	},
	saveInboundRemarks(body) {
		return this.post("/fam/save_inbound_remark", body);
	},
	getMonthlyPayoutList(body) {
		return this.post("/reward/get_monthly_payout_list", body);
	},
	rejectMonthlyPayoutRecords(body) {
		return this.post("/reward/monthly-payout/reject", body);
	},
	approveMonthlyPayoutRecords(body) {
		return this.post("/reward/monthly-payout/approve", body);
	},
	// saveOtherTransactionRemarks(body) {
	// 	return this.post("/fam/save_other_transaction_remark", body);
	// },

	getCustomerPaymentCheck(body) {
		return this.post("/payment/get_customer_payment_charge", body);
	},

	getReportNew(body, endPoint) {
		return this.post(`reports/${endPoint}`, body);
	},
	bulkUploadFID(body) {
		return this.post("/lead/upload_fid_lead", body);
	},
	updateFidFlag(body) {
		return this.post("/lead/update_fid_flag", body);
	},

	getSignedUrl(body) {
		return this.post("/common/get_signed_url", body);
	},
	getReconcilePaymentReports(body) {
		return this.post("/reports/get_reconcile_report", body);
	},

	/**
	 * This service is using for bulk uploading additional revenue
	 * @param {*} body 
	 * @param {*} headers 
	 * @returns 
	 */
	bulkUploadAdditionalRevenue(body, headers) {
		return this.post("payment/save/bulk-additional-revenue", body, headers);
	},

	/**
	 * This service is using for fetching additional revenue which is already bulk uploaded
	 * @param {*} body 
	 * @param {*} headers 
	 * @returns 
	 */
	downloadBulkAdditionalRevenue(body, headers) {
		return this.post("payment/download-bulk-additional-revenue", body, headers);
	},

	getTenantBankList(body) {
		return this.post("/bank/pb_bank_list", body);
	},
	getAllocationHistory(body) {
		return this.post("/fam/get_inbound_allocation_history", body);
	},
	getEditedLoanAfterDisbursal(body) {
		return this.post("/fam/get_edited_loan_list", body);
	},
	getMarkAsEditLeadTranch(body) {
		return this.post("/fam/get_edited_leads", body);
	},
	inboundUpdatePaymentEditLoan(body) {
		return this.post("fam/inbound_payment_update_edit_loan", body);
	},
	getcbiReport(body){
		return this.post('/reports/get_cbi_report',body);
	},
	getIncentivePayout(body){
		return this.post('/user-incentive/get-incentive-payout',body)
	},
	getIncentiveUploadDetail(body){
		return this.post('/user-incentive/get-incentive-payout-detail',body);
	},
	getIncentiveUploadTable(body){
		return this.post('/user-incentive/incentive-payout-upload-summary',body);
	},
	getDeductionSummary(body){
		return this.post('/user-incentive/incentive-payout-deduction-summary',body)
	},
	getBatchNumber(body){
		return this.post('/user-incentive/get_upload_batch_number',body);
	},
	updateUserIncentiveAssign(body) {
		return this.post('/user-incentive/update_outbound_assign_tranch',body);
	},
	uploadIncentivePayment(body) {
		return this.post('/user-incentive/upload_incentive_payment',body);
	},  
	updateIncentivePayoutStatus(body) {
		return this.post('/user-incentive/update-incentive-payout-status',body);
	},
	getReuploadDetail(body) {
		return this.post('/user-incentive/reupload_lad_details',body);
	},
	getReuploadSummary(body) {
		return this.post('/user-incentive/reupload_summary',body);
	},
	getSalesIncentivePayoutOutbondList(body) {
		return this.post("fam/get_sales_incentive_payout_outbound_list", body);
	},
	getDeductionHistory(body) {
		return this.post('/user-incentive/deduction_history',body);
	},  

	getUserIncentiveUploadStatusHistory(body) {
		return this.post('/user-incentive/get-incentive-status-history',body);
	},
	getDeductionSummaryofBatch(body) {
		return this.post('/user-incentive/get-deduction-summary-of-batch',body);
	},
	getAutoDeductionApprove(body) {
		return this.post('/user-incentive/approve-auto-deduction',body)
	},
	getOutboundTabCounts(body) {
		return this.post("/fam/get_outbound_tab_counts", body);
	},
	getBpjsuploadDetail(body) {
		return this.post('/user-incentive/bpjsupload_details',body);
	},
	getBpjsuploadSummary(body) {
		return this.post('/user-incentive/bpjsupload_summary',body);
	}, 
	getArrearSummary(body){
		return this.post('/user-incentive/get-arrear-summary',body)
	}, 
	getArrearHistory(body){
		return this.post('/user-incentive/arrear_history',body)
	},
	resetFinancier(body) {
		return this.post("/fam/reset_financier", body);
	},
	getCbiPdf(body){
		return this.post('/lead/get_cbi_pdf_url',body)
	},
	getcbiStatus(body){
		return this.post('/lead/check_cbi_status',body)
	},
	getUCFPendingStatements(body){
		return this.post('/wallet/get_ucf_pending_statements',body)
	},	
	updateBusinessLineUtr(body){
		return this.post('/fam/change_utr_business',body)
	} 
};


export default serviceList;
